import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Col, Row, Button, Form, Label, Input } from 'reactstrap';
import Select from 'react-select'; // React Select for dropdowns
import { addSiteSurvey, getTeams, getSiteSurveys, getSolutions, getSebelUsers } from 'store/actions'; // Actions for fetching and adding Site Surveys
import CreateSiteSurvey from './CreateSiteSurvey'; // Modal or form to create a Site Survey
import SiteSurveyTable from './SiteSurveyTable'; // Table to display Site Surveys
import Breadcrumb from 'components/Common/Breadcrumb2'; // Breadcrumb component
import { convertDateFormat, convertToDateOnly2 } from 'helpers/dateFormat_helper';
import Cookies from 'js-cookie';
import { showError } from 'helpers/notification_helper';


const SiteSurveyList = () => {
    const [isOpen, setIsOpen] = useState(false); // State to control the modal visibility
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [createdAt, setCreatedAt] = useState();
    const [selectedTeam, setSelectedTeam] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedSolution, setSelectedSolution] = useState(null);
    const [sebelUserId, setSebelUserId] = useState(null);
    const [pageIndex, setPageIndex] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [sorting, setSorting] = useState([{ id: 'siteSurveyNumber', desc: false }]);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchVal, setSearchVal] = useState("");
    const id = JSON.parse(Cookies.get('authUser'))?.userId

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    // Selectors to access Redux state
    const SiteSurveys = useSelector((state) => state.SiteSurvey.sitesurveys);
    const totalCount = useSelector((state) => state.SiteSurvey.totalCount);
    const sebelUsers = useSelector((state) => state.SebelUser.users);
    const solutions = useSelector(state => state.Solution.solutions);
    const teams = useSelector((state) => state?.Team?.teams)
    const loading = useSelector((state) => state.SiteSurvey.loading);
    const error = useSelector((state) => state.SiteSurvey.error);

    const cookieEndDate = Cookies.get('siteSurveyEndDate');
    const cookieStartDate = Cookies.get('siteSurveyStartDate');
    const cookieSelectedTeam = Cookies.get('siteSurveySelectedTeam') ? JSON.parse(Cookies.get('siteSurveySelectedTeam')) : "";
    const cookieSelectedStatus = Cookies.get('siteSurveySelectedStatus') ? JSON.parse(Cookies.get('siteSurveySelectedStatus')) : "";
    const cookieSelectedSolution = Cookies.get('siteSurveySelectedSolution')
    const cookieSebelUserId = Cookies.get('siteSurveySebelUserId')
    const cookieCreatedAt  = Cookies.get('siteSurveyCreatedAt')
    // Fetch permissions from localStorage
    const permissions2 = JSON.parse(localStorage?.getItem('permissions'));
    // Sample team and status options (replace with actual data if available)
    const teamOptions = teams?.Data?.map(item => ({ label: item?.teamName, value: item?.teamId }))

    const statusOptions = [
        { value: 'SiteSurvey Completed', label: 'SiteSurvey Completed' },
        { value: 'SiteSurvey Created', label: 'SiteSurvey Created' },
        { value: 'SiteSurvey Cancelled', label: 'SiteSurvey Cancelled' },
    ];
    const solutionOptions = [
        { value: 'iot', label: 'IOT' },
        { value: '5g', label: '5G' },
    ];
    const sebeleIdOptions = [];

    const getColumnIndex = (accessorKey) => {
        const mapping = {
            'siteSurveyNumber': 0,
            'teamName': 1,
            'customerNameEng': 2,
            'contactNumber1': 3,
            'createdBy': 4,
            'scheduledStartDateTime': 5,
            'scheduledEndDateTime': 6,
            'SiteSurveyStatus': 7
        };
        return mapping[accessorKey] !== undefined ? mapping[accessorKey] : 0;
    };

    useEffect(() => {
        const hasCookies = (cookieEndDate || cookieStartDate || cookieSelectedTeam || cookieSelectedStatus || cookieSebelUserId || cookieSelectedSolution || cookieCreatedAt);
        if (loading || (hasCookies && !location?.state?.cameFromSiteSurvey)) return;
        
        dispatch(getTeams(true))
        dispatch(getSolutions())
        dispatch(getSebelUsers())
        
        const sortColId = sorting[0]?.id || 'siteSurveyNumber';
        const sortCol = getColumnIndex(sortColId);
        const sortDir = sorting[0]?.desc ? 'DESC' : 'ASC';

        dispatch(getSiteSurveys(id, selectedStatus?.value, convertDateFormat(startDate), convertDateFormat(endDate), selectedTeam?.value,selectedSolution,sebelUserId,convertToDateOnly2(createdAt), pageSize, pageIndex * pageSize, sortCol, sortDir, searchTerm));
    }, [dispatch, pageIndex, pageSize, sorting, searchTerm]);

    const handleSearch = () => {
        if ( endDate && new Date(startDate) > new Date(endDate)) {
            showError("End datetime must be after start datetime");
        } else {
            setPageIndex(0);
            setSearchTerm(searchVal);
        }
    };

    useEffect(() => {
        if (cookieEndDate && location?.state?.cameFromSiteSurvey) {
            setEndDate(cookieEndDate);
        }
        if (cookieStartDate && location?.state?.cameFromSiteSurvey) {
            setStartDate(cookieStartDate);
        }
        if (cookieSelectedTeam && location?.state?.cameFromSiteSurvey) {
            setSelectedTeam(cookieSelectedTeam);
        }
        if (cookieSelectedStatus && location?.state?.cameFromSiteSurvey) {
            setSelectedStatus(cookieSelectedStatus);
        }
        if (cookieSebelUserId && location?.state?.cameFromSiteSurvey) {
            setSebelUserId(cookieSebelUserId);
        }
        if (cookieSelectedSolution && location?.state?.cameFromSiteSurvey) {
            setSelectedSolution(cookieSelectedSolution);
        }
        if (cookieCreatedAt && location?.state?.cameFromSiteSurvey) {
            setCreatedAt(cookieCreatedAt);
        }
        if ((cookieEndDate || cookieStartDate || cookieSelectedTeam || cookieSelectedStatus || cookieSebelUserId || cookieSelectedSolution || cookieCreatedAt) && location?.state?.cameFromSiteSurvey) {
            const sortColId = sorting[0]?.id || 'siteSurveyNumber';
            const sortCol = getColumnIndex(sortColId);
            const sortDir = sorting[0]?.desc ? 'DESC' : 'ASC';
            dispatch(getSiteSurveys(id, cookieSelectedStatus?.value, convertDateFormat(cookieStartDate), convertDateFormat(cookieEndDate), cookieSelectedTeam?.value, cookieSelectedSolution, cookieSebelUserId, convertToDateOnly2(cookieCreatedAt), pageSize, pageIndex * pageSize, sortCol, sortDir, searchTerm));
        }
        Cookies.remove('siteSurveyEndDate');
        Cookies.remove('siteSurveyStartDate');
        Cookies.remove('siteSurveySelectedTeam');
        Cookies.remove('siteSurveySelectedStatus');
        Cookies.remove('siteSurveySelectedSolution');
        Cookies.remove('siteSurveySebelUserId');
        Cookies.remove('siteSurveyCreatedAt');
    }, [location]);

    useEffect(() => {
        localStorage.setItem('siteSurveyEndDate', endDate);
        localStorage.setItem('siteSurveyStartDate', startDate);
        localStorage.setItem('siteSurveySelectedTeam', JSON.stringify(selectedTeam));
        localStorage.setItem('siteSurveySelectedStatus', JSON.stringify(selectedStatus));
        localStorage.setItem('siteSurveySelectedSolution', selectedSolution);
        localStorage.setItem('siteSurveySebelUserId',sebelUserId);
        localStorage.setItem('siteSurveyCreatedAt',createdAt);
    }, [endDate, startDate, selectedStatus, selectedTeam, location,sebelUserId,selectedSolution,createdAt])
    return (
        <>
            <div className='page-content container-fluid'>
                <div className='d-flex justify-content-between align-items-center mx-3'>
                    <Breadcrumb
                        title="Site Surveys"
                        breadcrumbItems={[
                            { title: "Dashboard", link: `/dashboard` },
                            { title: "Site Surveys", link: '#' }
                        ]}
                    />
                    {permissions2?.map(item => item?.permissionName)?.includes("Add SiteSurvey") && (
                        <Button
                            className='bg-primary text-white d-flex justify-content-center gap-1 align-items-center'
                            onClick={() => navigate(`/createSiteSurvey`)}
                        >
                            <i className='ti-plus'></i> Add New
                        </Button>
                    )}
                </div>

                {/* Filters Section */}
                <div className='filters-section mx-3'>
                    <Form className="my-3">
                        <Row className="g-3">
                            {/* Start Date */}
                            <Col xs={6} md={3}>
                                <Label for="startDate">Start Date</Label>
                                <Input
                                    type="datetime-local"
                                    id="startDate"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                            </Col>

                            {/* End Date */}
                            <Col xs={6} md={3}>
                                <Label for="endDate">End Date</Label>
                                <Input
                                    type="datetime-local"
                                    id="endDate"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                            </Col>
                             {/* Created Date */}
                            <Col xs={6} md={3}>
                                <Label for="createdAt">Created Date</Label>
                                <Input
                                    type="date"
                                    id="createdAt"
                                    value={createdAt ? createdAt : ""}
                                    onChange={(e) => setCreatedAt(e.target.value)}
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                            </Col>

                            {/* Team Selector */}
                            <Col xs={6} md={3}>
                                <Label for="team">Team</Label>
                                <Select
                                    id="team"
                                    options={teamOptions}
                                    value={selectedTeam}
                                    onChange={setSelectedTeam}
                                    placeholder="Select Team"
                                    isClearable={true}
                                />
                            </Col>

                            {/* Site Survey Status Selector */}
                            <Col xs={6} md={3}>
                                <Label for="status" className='mt-1'>Status</Label>
                                <Select
                                    id="status"
                                    options={statusOptions}
                                    value={selectedStatus}
                                    onChange={setSelectedStatus}
                                    placeholder="Select Status"
                                    isClearable={true}
                                />
                            </Col>

                            {/* Work Order Solution Selector */}
                            <Col xs={6} md={3}>
                                <Label for="solution" className='mt-1'>Solution</Label>
                                <Select
                                    id="solution"
                                    options={solutions?.map(item=>({label:item?.solutionName,value:item?.solutionId}))}
                                    value={solutions?.map(item=>({label:item?.solutionName,value:item?.solutionId}))?.find(option => option?.value == selectedSolution)||""}
                                    onChange={option => { setSelectedSolution(option?.value);}}
                                    placeholder="Select Solution"
                                    isClearable={true}
                                />
                            </Col>
                            {/* Work Order Sebele User ID */}
                            <Col xs={6} md={3}>
                                <Label for="sebelUserId" className='mt-1'>Siebel User ID</Label>
                                <Select
                                    id="sebelUserId"
                                    options={sebelUsers?.Data?.map(item=>({label:item?.sabelUserId,value:item?.id}))}
                                    value={sebelUsers?.Data?.map(item=>({label:item?.sabelUserId,value:item?.id}))?.find(option=>option?.value == sebelUserId || "")}
                                    onChange={option=>{setSebelUserId(option?.value)}}
                                    placeholder="Select Siebel User ID"
                                    isClearable={true}
                                />
                            </Col>
                            <Col xs={6} md={3}>
                                <Label for="searchField" className='mt-1'>Search</Label>
                                <Input
                                    type="text"
                                    id="searchField"
                                    placeholder="Search..."
                                    value={searchVal}
                                    onChange={(e) => setSearchVal(e.target.value)}
                                    style={{ height: "38px", border: "1px solid lightgray" }}
                                />
                            </Col>
                            <Col xs={6} md={3} className='d-flex justify-start align-center'>
                                <Button color="primary mt-auto" style={{ marginBottom: '2px' }} onClick={handleSearch}>Search</Button>
                            </Col>
                        </Row>
                    </Form>
                </div>

                {/* Site Surveys Table */}
                <SiteSurveyTable 
                    loading={loading} 
                    List={SiteSurveys?.Data} 
                    totalCount={totalCount}
                    pageIndex={pageIndex}
                    pageSize={pageSize}
                    sorting={sorting}
                    onPaginationChange={(state) => {
                        setPageIndex(state.pageIndex);
                        setPageSize(state.pageSize);
                    }}
                    onSortingChange={setSorting}
                    onGlobalFilterChange={setSearchTerm}
                />
            </div>
        </>
    );
};

export default SiteSurveyList;
